import { useEffect } from "react";

// Native scrolling handles touch and trackpads; retain dragging with a mouse.
export default function useHorizontalDrag(track) {
  useEffect(() => {
    if (!track) return;
    let drag;
    let suppressClick = false;
    const down = (event) => {
      suppressClick = false;
      if (event.pointerType !== "mouse" || event.button !== 0) return;
      drag = {
        x: event.clientX,
        y: event.clientY,
        left: track.scrollLeft,
        id: event.pointerId,
        active: false
      };
    };
    const move = (event) => {
      if (!drag || event.pointerId !== drag.id) return;
      const dx = event.clientX - drag.x;
      const dy = event.clientY - drag.y;
      if (!drag.active) {
        if (Math.max(Math.abs(dx), Math.abs(dy)) < 6) return;
        if (Math.abs(dy) > Math.abs(dx)) {
          drag = null;
          return;
        }
        drag.active = true;
        drag.snapType = track.style.scrollSnapType;
        track.style.scrollSnapType = "none";
        suppressClick = true;
        track.setPointerCapture(event.pointerId);
      }
      event.preventDefault();
      track.scrollLeft = drag.left - dx;
    };
    const end = () => {
      const finished = drag;
      drag = null;
      if (finished?.active) track.style.scrollSnapType = finished.snapType;
      if (finished && track.hasPointerCapture(finished.id))
        track.releasePointerCapture(finished.id);
    };
    const click = (event) => {
      if (!suppressClick) return;
      suppressClick = false;
      // A release outside the track may produce no click. Never swallow a
      // later Enter/Space or assistive-technology activation in its place.
      if (event.detail === 0) return;
      event.preventDefault();
      event.stopPropagation();
    };
    const preventImageDrag = (event) => event.preventDefault();
    track.addEventListener("pointerdown", down);
    track.addEventListener("pointermove", move);
    track.addEventListener("pointerup", end);
    track.addEventListener("pointercancel", end);
    track.addEventListener("pointerleave", end);
    track.addEventListener("lostpointercapture", end);
    window.addEventListener("blur", end);
    track.addEventListener("click", click, true);
    track.addEventListener("dragstart", preventImageDrag);
    return () => {
      end();
      track.removeEventListener("pointerdown", down);
      track.removeEventListener("pointermove", move);
      track.removeEventListener("pointerup", end);
      track.removeEventListener("pointercancel", end);
      track.removeEventListener("pointerleave", end);
      track.removeEventListener("lostpointercapture", end);
      window.removeEventListener("blur", end);
      track.removeEventListener("click", click, true);
      track.removeEventListener("dragstart", preventImageDrag);
    };
  }, [track]);
}
